import { ERC20 as ERC20Abi } from '../abis';
import { executeTx } from './executeTx';
import { getContract } from './getContract';
export async function approveIfRequired(tokenAddress, spenderAddress, amount, signerOrProvider) {
    const tokenContract = getContract(tokenAddress, ERC20Abi, signerOrProvider);
    const [approvedAmount, userBalance] = await Promise.all([
        tokenContract.allowance(await signerOrProvider.getAddress(), spenderAddress),
        tokenContract.balanceOf(await signerOrProvider.getAddress()),
    ]);
    if (approvedAmount < amount) {
        const approveTx = tokenContract.approve(spenderAddress, userBalance);
        await executeTx(approveTx);
    }
}
